<template>
  <div class="ytbvideo">
    <div class="ytbvideo_title">DeepLink Youtube</div>
    <div class="ytbvideo_cont">
      <div class="ytbvideo_li" v-for="(el, index) in youtubeData" @click="linkhref(el.link)" v-show='YTBShow ? index < 12 : index < 100'>
        <img class="li_img" v-lazy="el.img" alt="">
        <div class="li_title">{{ el.name }}</div>
        <div class="video_info">
          <img class="img" v-lazy="el.channel_img" alt="">
          <div class="name">
            <div class="title">{{ el.channels }}</div>
            <div class="text">{{ el.watchTime }}</div>
          </div>
          <div class="time">{{ el.time }}</div>
        </div>
      </div>
    </div>
    <div v-if="youtubeData.length > 12" class="seeMore" @click="YTBShow = !YTBShow">{{ YTBShow ? $t('showMore') : $t('hideMore') }}</div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex";
  
  import ytb_img27 from "@/assets/media/ytb_img27.webp"
  import ytb_img26 from "@/assets/media/ytb_img26.webp"
  import ytb_img25 from "@/assets/media/ytb_img25.webp"
  import ytb_img24 from "@/assets/media/ytb_img24.webp"
  import ytb_img23 from "@/assets/media/ytb_img23.webp"
  import ytb_img22 from "@/assets/media/ytb_img22.webp"
  import ytb_img21 from "@/assets/media/ytb_img21.webp"
  import ytb_img20 from "@/assets/media/ytb_img20.webp"
  import ytb_img19 from "@/assets/media/ytb_img19.webp"
  import ytb_img18 from "@/assets/media/ytb_img18.webp"
  import ytb_img17 from "@/assets/media/ytb_img17.webp"
  import ytb_img16 from "@/assets/media/ytb_img16.webp"
  import ytb_img15 from "@/assets/media/ytb_img15.webp"
  import ytb_img14 from "@/assets/media/ytb_img14.webp"
  import ytb_img13 from "@/assets/media/ytb_img13.webp"
  import ytb_img12 from "@/assets/media/ytb_img12.webp"
  import ytb_img11 from "@/assets/media/ytb_img11.webp"
  import ytb_img10_1 from "@/assets/media/ytb_img10_1.webp"
  import ytb_img10 from "@/assets/media/ytb_img10.webp"
  import ytb_img9_1 from "@/assets/media/ytb_img9_1.webp"
  import ytb_img9 from "@/assets/media/ytb_img9.webp"
  import ytb_img8 from "@/assets/media/ytb_img8.webp"
  import ytb_img7 from "@/assets/media/ytb_img7.webp"
  import ytb_img6_1 from "@/assets/media/ytb_img6_1.webp"
  import ytb_img6 from "@/assets/media/ytb_img6.webp"
  import ytb_img5_1 from "@/assets/media/ytb_img5_1.webp"
  import ytb_img5 from "@/assets/media/ytb_img5.webp"
  import ytb_img4 from "@/assets/media/ytb_img4.webp"
  import ytb_img3_1 from "@/assets/media/ytb_img3_1.webp"
  import ytb_img3 from "@/assets/media/ytb_img3.webp"
  import ytb_img2 from "@/assets/media/ytb_img2.webp"
  import ytb_img1_1 from "@/assets/media/ytb_img1_1.webp"
  import ytb_img1 from "@/assets/media/ytb_img1.webp"

  
  import youtube_channels from "@/assets/media/youtube_channels.jpg"
  import youtube_channels1 from "@/assets/media/youtube_channels1.jpg"
  import youtube_channels2 from "@/assets/media/youtube_channels2.jpg"
  import youtube_channels3 from "@/assets/media/youtube_channels3.jpg"
  import youtube_channels4 from "@/assets/media/youtube_channels4.jpg"
  import youtube_channels5 from "@/assets/media/youtube_channels5.jpg"
  import youtube_channels6 from "@/assets/media/youtube_channels6.jpg"
  import youtube_channels7 from "@/assets/media/youtube_channels7.jpg"
  import youtube_channels8 from "@/assets/media/youtube_channels8.jpg"
  import youtube_channels9 from "@/assets/media/youtube_channels9.jpg"
  import youtube_channels10 from "@/assets/media/youtube_channels10.jpg"
  import youtube_channels11 from "@/assets/media/youtube_channels11.jpg"
  import youtube_channels12 from "@/assets/media/youtube_channels12.jpg"
  import youtube_channels13 from "@/assets/media/youtube_channels13.jpg"
  import youtube_channels14 from "@/assets/media/youtube_channels14.jpg"
  import youtube_channels15 from "@/assets/media/youtube_channels15.jpg"
  import youtube_channels16 from "@/assets/media/youtube_channels16.jpg"
  import youtube_channels17 from "@/assets/media/youtube_channels17.jpg"
  import youtube_channels18 from "@/assets/media/youtube_channels18.jpg"
  import youtube_channels19 from "@/assets/media/youtube_channels19.jpg"
  import youtube_channels20 from "@/assets/media/youtube_channels20.jpg"
  export default defineComponent({
    name: 'ytbvideo',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const youtubeData = ref([
        // {
        //   name: 'Playing GTA 5 On My *10 Year* Old Laptop 😱 App That Can Run GTA 5 At 120 FPS 😍 Deeplink Cloud',
        //   link: 'https://www.youtube.com/watch?v=TfugE5HReks',
        //   channels: 'Awesome Genome',
        //   watchTime: '6,329 views',
        //   time: '2024-06-30',
        //   img: ytb_img27,
        //   channel_img: youtube_channels20
        // }, 
        // {
        //   name: 'Playing GTA 5 On My 10 Year Old Laptop😱| DeepLink Cloud + Nvidia | PLAY HIGH END GAMES On LOW END PC',
        //   link: 'https://www.youtube.com/watch?v=TwlgfYaD_yw',
        //   channels: 'MohiT GaminG WorlD',
        //   watchTime: '21,741 views',
        //   time: '2024-06-09',
        //   img: ytb_img26,
        //   channel_img: youtube_channels19
        // },  
        // {
        //   name: 'Play GTA 5 & AAA Games On Low End Laptop 😱 | New Deep Link Cloud Gaming | 4k 60 FPS',
        //   link: 'https://www.youtube.com/watch?v=l16FPK569qE',
        //   channels: 'Lazy Assassin',
        //   watchTime: '50,645 views',
        //   time: '2024-06-06',
        //   img: ytb_img25,
        //   channel_img: youtube_channels18
        // },
        // {
        //   name: '【DeepLink（ディープリンク）】時価総額2兆ドル越えの大企業Nvidiaがサポート！GPUに革命をもたらす仮想通貨プロジェクトのDLCトークンを今のうちに仕込もう',
        //   link: 'https://www.youtube.com/watch?v=X7BMfZAjn8Y',
        //   channels: '【政岡吉宗】仮想通貨',
        //   watchTime: '312 views',
        //   time: '2024-05-30',
        //   img: ytb_img24,
        //   channel_img: youtube_channels17
        // },
        // {
        //   name: 'イーロンマスク×AI【大手取引所5つに上場確定】未上場トークン！株価130倍高騰のNVIDIAと提携【仮想通貨】',
        //   link: 'https://www.youtube.com/watch?v=pl0NOmobEfo',
        //   channels: '【投資家　ゲン】視聴者1万人・億りびと化計画',
        //   watchTime: '1,542 views',
        //   time: '2024-05-31',
        //   img: ytb_img23,
        //   channel_img: youtube_channels16
        // },
        // {
        //   name: 'DEEPLİNK PROJE İNCELEMESİ ! 🔥- 5 HAZİRANDA ÖN SATIŞ BAŞLIYOR ! 🚀',
        //   link: 'https://www.youtube.com/watch?v=a6qWJ6dfLJQ',
        //   channels: 'Crypto Ertan',
        //   watchTime: '9,945 views',
        //   time: '2024-05-31',
        //   img: ytb_img22,
        //   channel_img: youtube_channels15
        // },
        // {
        //   name: 'DEEPLINK具有巨大潛力的遊戲專案平台 ~~平台幣$DLC即將啟售 英偉達（NVIDIA）激勵計劃',
        //   link: 'https://www.youtube.com/watch?v=fTyaxXHIh5M',
        //   channels: '小米會計師 Little Rice',
        //   watchTime: '1,542 views',
        //   time: '2024-05-29',
        //   img: ytb_img21,
        //   channel_img: youtube_channels14
        // },
        // {
        //   name: 'DeepLink Review: Innovative Platform for Cloud Gaming and Cryptocurrencies // Join Public Sale',
        //   link: 'https://www.youtube.com/watch?v=a6yX8zv0yHw',
        //   channels: 'CRYPTO LADY',
        //   watchTime: '79,230 views',
        //   time: '2024-05-29',
        //   img: ytb_img20,
        //   channel_img: youtube_channels13
        // },
        // {
        //   name: 'Playing GTA 5 On My *8 Year* Old Laptop😱| DeepLink Cloud + Nvidia| PLAY HIGH END GAMES On LOW END PC',
        //   link: 'https://www.youtube.com/watch?v=JlN01yOlZOw',
        //   channels: 'Wasim Gamer Hindi',
        //   watchTime: '27,746 views',
        //   time: '2024-05-28',
        //   img: ytb_img19,
        //   channel_img: youtube_channels12
        // },
        // {
        //   name: '【Deeplink（ディープリンク）】時価総額366兆円Nvidiaと提携した激熱銘柄公開‼期待値200倍!?【BTC（ビットコイン）】【仮想通貨】',
        //   link: 'https://www.youtube.com/watch?v=RKYDssID0q4',
        //   channels: '仮想通貨 投資家カズキー',
        //   watchTime: '1,515 views',
        //   time: '2024-05-20',
        //   img: ytb_img18,
        //   channel_img: youtube_channels11
        // },
        // {
        //   name: '【 DEEPLINK ( ディープリンク ) 】世界3位の企業‼10年で130倍‼NVIDIAが完全提携‼AI×GPU×ゲーム銘柄が今なら上場前に仕込める‼ここから爆上がりする銘柄を解説‼',
        //   link: 'https://www.youtube.com/watch?v=ubBYeZvnu2w',
        //   channels: '仮想通貨ジャパン',
        //   watchTime: '1,922 views',
        //   time: '2024-05-20',
        //   img: ytb_img17,
        //   channel_img: youtube_channels10
        // },
        // {
        //   name: 'Dự Án DEEPLINK Làm Về A.I Cloud Gaming - Tiềm Năng Mới Trong Giới Crypto',
        //   link: 'https://www.youtube.com/watch?v=7_Aj4h-yDtg',
        //   channels: 'Đầu Tư Tiền Điện Tử',
        //   watchTime: '1,181 views',
        //   time: '2024-05-20',
        //   img: ytb_img16,
        //   channel_img: youtube_channels9
        // },
        // {
        //   name: '※時価総額366兆円の米国3位企業が提携したコインを保有できれば間違いなく勝ち組！ビットコイン買うなら絶対にこのコインを買え！',
        //   link: 'https://www.youtube.com/watch?v=8r7_G1NpCdc',
        //   channels: '仮想通貨マンチャンネル【仮想通貨で億り人】',
        //   watchTime: '1,783 views',
        //   time: '2024-05-17',
        //   img: ytb_img15,
        //   channel_img: youtube_channels8
        // },
        // {
        //   name: 'BITCOIN NEXT TARGET $80,000 🤑 | पिक्चर अभी बाकी है | Deeplink (DLC) Token New Crypto',
        //   link: 'https://www.youtube.com/watch?v=L2YOrZgxTbg',
        //   channels: 'TODAY CRYPTO',
        //   watchTime: '4,917 views',
        //   time: '2024-05-17',
        //   img: ytb_img14,
        //   channel_img: youtube_channels7
        // },
        // {
        //   name: '【今最もアツい企業NVIDIA銘柄】最新AI銘柄で先行者利益を狙え！BTCよりも上昇しているNVIDIAとパートナー提携！上場前に獲得できる方法も解説します！',
        //   link: 'https://www.youtube.com/watch?v=IaBZK8vphF8',
        //   channels: '海外投資家マイケル・ケンゾー【仮想通貨情報局】',
        //   watchTime: '1,289 views',
        //   time: '2024-05-16',
        //   img: ytb_img13,
        //   channel_img: youtube_channels6
        // },
        {
          name: 'DeepLink X DeepBrain Chain Conference_Blockchain in Cheongdam.', // new
          link: 'https://www.youtube.com/watch?v=jjgEAQwDC4Y',
          channels: 'DeepLink Global',
          watchTime: '110 views',
          time: '2024-06-21',
          img: ytb_img10_1,
          channel_img: youtube_channels
        },
        {
          name: '🔥Play with DeepLink 🔥 New 1 0 2 version Launched.', // new
          link: 'https://www.youtube.com/watch?v=gEWtuReTY30',
          channels: 'DeepLink Global',
          watchTime: '1,185 views',
          time: '2024-06-05',
          img: ytb_img9_1,
          channel_img: youtube_channels
        },
        {
          name: '🔥PLAY WITH DEEPLINK x TESLA🎮: Enjoy gaming experiences in TESLA. Driving breaks made better.',
          link: 'https://www.youtube.com/watch?v=o4CE2UYD6QA',
          channels: 'DeepLink Global',
          watchTime: '1,060 views',
          time: '2024-05-15',
          img: ytb_img12,
          channel_img: youtube_channels
        },
        {
          name: 'Inside DeepLink and Public sale Preparations',
          link: 'https://www.youtube.com/watch?v=T86MBoTeRB8',
          channels: 'DeepLink Global',
          watchTime: '3,890 views',
          time: '2024-05-02',
          img: ytb_img11,
          channel_img: youtube_channels
        },
        {
          name: 'DeepLink participates in HTX Dubai event as the major sponsor', // new
          link: 'https://www.youtube.com/watch?v=DXQAncIO7X8',
          channels: 'DeepLink Global',
          watchTime: '1,071 views',
          time: '2024-04-23',
          img: ytb_img6_1,
          channel_img: youtube_channels
        },
        {
          name: 'DeepLink meet-up event_ Bangalore', // new
          link: 'https://www.youtube.com/watch?v=8rGsU0XPLTw',
          channels: 'DeepLink Global',
          watchTime: '2,091 views',
          time: '2024-04-10',
          img: ytb_img5_1,
          channel_img: youtube_channels
        },
        // {
        //   name: "YAPAY ZEKA LİDERİ NVIDIA'NIN İŞ ORTAĞI RENDER COİN RAKİBİ DEEPLINK ALINIR MI? ALTCOİN ANALİZ",
        //   link: 'https://www.youtube.com/watch?v=ItTf4j2GVjU', // youtube_channels1
        //   channels: 'Kripto Sözlük',
        //   watchTime: '4,196 views',
        //   time: '2024-05-17',
        //   img: ytb_img10,
        //   channel_img: youtube_channels1
        // },
        // {
        //   name: '【仮想通貨】今最もアツい企業NVIDIAと提携！先行者利益を総取りできる未上場コイン！【仮想通貨バブル】【ソラナ（solana）】',
        //   link: 'https://www.youtube.com/watch?v=XQZ70PQ79Qk', // youtube_channels2
        //   channels: '億り人生産機チャンネル【仮想通貨】',
        //   watchTime: '1,323 views',
        //   time: '2024-05-15',
        //   img: ytb_img9,
        //   channel_img: youtube_channels2
        // },
        // {
        //   name: '【仮想通貨】株価130倍高騰のNVIDIAが手掛けるDeepLink!!SHIBやCAWなどのミームよりAIで先行者利益を獲れ!!',
        //   link: 'https://www.youtube.com/watch?v=W1O18gl_PD8',
        //   channels: 'クリプト億太郎【仮想通貨でセミリタイア】', // youtube_channels3
        //   watchTime: '1,031 views',
        //   time: '2024-05-16',
        //   img: ytb_img8,
        //   channel_img: youtube_channels3
        // },
        // {
        //   name: 'Cloud Gaming Project with SERIOUS POTENTIAL!',
        //   link: 'https://www.youtube.com/watch?v=JCJv3D1KW98',
        //   channels: 'CryptoJar', // youtube_channels4
        //   watchTime: '1,073 views',
        //   time: '2024-05-09',
        //   img: ytb_img7,
        //   channel_img: youtube_channels4
        // },
        // {
        //   name: 'DeepLink x Nvidia + AI + DePIN + Gamefi - The Future Of Cloud Gaming Is Here!',
        //   link: 'https://www.youtube.com/watch?v=IyrjxugZuSg',
        //   channels: 'Farrington Crypto', // youtube_channels5
        //   watchTime: '579 views',
        //   time: '2024-05-06',
        //   img: ytb_img6,
        //   channel_img: youtube_channels5
        // },
        // {
        //   name: '🔥Welcome to DEEPLINK CLOUD GAMING🎮: Enjoy high-end gaming experiences even on low-end laptop/PC🚀',
        //   link: 'https://www.youtube.com/watch?v=dAdjSXhD_y4',
        //   channels: 'DeepLink Global',
        //   watchTime: '16,394 views',
        //   time: '2023-07-19',
        //   img: ytb_img5,
        //   channel_img: youtube_channels
        // },
        {
          name: 'リモートゲームの再定義 - DeepLink プロトコル - Web 3.0 - 低スペックなデバイスで高品質なゲームをプレイ',
          link: 'https://www.youtube.com/watch?v=ag45tJTdeTQ',
          channels: 'DeepLink Global',
          watchTime: '3,187 views',
          time: '2024-02-16',
          img: ytb_img4,
          channel_img: youtube_channels
        },
        {
          name: 'DeepLink Protocol - Web 3.0 - Refine Remote Games',
          link: 'https://www.youtube.com/watch?v=o6mWTc464ec',
          channels: 'DeepLink Global',
          watchTime: '4,933 views',
          time: '2024-02-15',
          img: ytb_img3_1,
          channel_img: youtube_channels
        },
        {
          name: 'START YOUR GAMING JOURNEY TODAY WITH DEEPLINK🔥🔥🔥',
          link: 'https://www.youtube.com/watch?v=S5fb4WausbU',
          channels: 'DeepLink Global',
          watchTime: '10,564 views',
          time: '2024-01-11',
          img: ytb_img3,
          channel_img: youtube_channels
        },
        {
          name: '🎮Play CONTROL by DEEPLINK🚀1ms ultra-low latency✨8K resolution⚡️Even on low-end laptop🔥',
          link: 'https://www.youtube.com/watch?v=dH7zbgFDZ90',
          channels: 'DeepLink Global',
          watchTime: '766 views',
          time: '2023-11-23',
          img: ytb_img1_1,
          channel_img: youtube_channels
        },
        // {
        //   name: '🔥SAVE 70% COST🔥CLOUD INTERNET CAFE & ESPORTS HOTEL:🌟DeepBrain Chain_Cloud GPU+DeepLink_Cloud Gaming🎮',
        //   link: 'https://www.youtube.com/watch?v=BIZDO9j-PAE',
        //   channels: 'DeepLink Global',
        //   watchTime: '13,590 views',
        //   time: '2023-09-07',
        //   img: ytb_img2,
        //   channel_img: youtube_channels
        // },
        // {
        //   name: '🔥Play Games at Cloud Internet Cafe in Korea🔥DeepBrain Chain_Cloud GPU+DeepLink_Cloud Gaming⚡',
        //   link: 'https://www.youtube.com/watch?v=mioE6SsEOLQ',
        //   channels: 'DeepLink Global',
        //   watchTime: '15,629 views',
        //   time: '2023-08-24',
        //   img: ytb_img1,
        //   channel_img: youtube_channels
        // }
      ])
      const YTBShow = ref(true)
      const linkhref = (val) => {
        window.open(val)
      }
      return {
        lan,
        YTBShow,
        linkhref,
        youtubeData
      };
    }
  })
</script>

<style scoped lang="scss">
.ytbvideo {
  width: 1200px;
  margin: 0 auto 60px;
  box-sizing: border-box;
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .ytbvideo_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 0.05em;
  }
  .ytbvideo_cont {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .ytbvideo_li {
      width: 380px;
      display: flex;
      cursor: pointer;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 12px;
      flex-direction: column;
      transition: all 1s ease-in-out;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .li_img {
        width: 380px;
        height: 210px;
      }
      .li_title {
        color: #fff;
        margin: 12px 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .video_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img {
          width: 38px;
          height: 38px;
          overflow: hidden;
          border-radius: 38px;
          display: inline-block;
        }
        .name {
          flex: 1;
          max-width: 68%;
          margin: 0 12px 0 5px;
          .title {
            color: #fff;
            font-size: 14px;
            font-weight: 500;
            line-height: 19px;
            letter-spacing: 0em;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .text {
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            overflow: hidden;
            white-space: nowrap;
            letter-spacing: 0em;
            text-overflow: ellipsis;
            color: rgba(255, 255, 255, 0.5);
          }
        }
        .time {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }
  
  .seeMore {
    display: table;
    font-size: 18px;
    cursor: pointer;
    font-weight: 500;
    line-height: 20px;
    padding: 10px 50px;
    margin: 20px auto 0;
    border-radius: 20px;
    letter-spacing: 0.08em;
    backdrop-filter: blur(6px);
    color: rgb(255, 255, 255);
    background: rgba(255, 255, 255, 0.1);
  }
}


@media screen and (max-width: 1200px) {
  .ytbvideo {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .ytbvideo_cont {
      .ytbvideo_li {
        width: 100%;
        overflow: hidden;
        margin-right: 0;
        border-radius: 20px;
        margin-bottom: 40px;
        .li_img {
          width: 100%;
          height: 360px;
          object-fit: cover;
        }
        .video_info {
          .img {
            width: 48px;
            height: 48px;
          }
          .name {
            flex: 1;
            width: unset;
          }
        }
      }
      
    }
  }
}
</style>